// extracted by mini-css-extract-plugin
export default {"remoteBadge":"RemoteBadge_remoteBadge__3J36t"};